import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Dropdown from 'components/cosmos/dropdown';
import PropTypes from 'prop-types';

const SchedulerItem = ({ item }) => {
  const { icon, label, onClick } = item;

  return (
    <Dropdown.MenuItem
      className="ca-scheduler__menu-item _pl-5 _pr-5"
      onClick={onClick}
      role="button"
    >
      <span className="ca-scheduler__item">
        <p data-test="ca-selector-label" className="ca-scheduler__label">
          {label}
        </p>
        {icon && <FontAwesomeIcon icon={['fal', 'arrow-right']} />}
      </span>
    </Dropdown.MenuItem>
  );
};

SchedulerItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string,
    icon: PropTypes.bool,
    onClick: PropTypes.func
  })
};

export default SchedulerItem;
